import { render, staticRenderFns } from "./RiskRaporlari.vue?vue&type=template&id=4545a4cd"
import script from "./RiskRaporlari.vue?vue&type=script&lang=js"
export * from "./RiskRaporlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports